import useQuery from "./useQuery";

export default function useCh() {
  const locationParams = useQuery()
  const ch = locationParams.get('ch')

  return ch || ''
}